import React from 'react';
import { ToolComponentProps } from './types';
import { cn } from '../../../lib/utils';
import { TaskContent } from './TaskContent';
import { ChevronDown, ChevronRight } from 'lucide-react';

export const TodosTool: React.FC<ToolComponentProps> = ({ 
  toolName, 
  input, 
  output, 
  isError,
  isExpanded,
  onToggle
}) => {
  // Parse the action from input if available
  const action = input?.action || 'unknown';

  return (
    <div className="space-y-2">
      {/* Tool header with expand/collapse */}
      <button
        onClick={onToggle}
        className="w-full flex items-center gap-2 font-medium hover:bg-accent/50 rounded p-1 -m-1 transition-colors"
      >
        {isExpanded ? (
          <ChevronDown className="w-4 h-4 text-muted-foreground" />
        ) : (
          <ChevronRight className="w-4 h-4 text-muted-foreground" />
        )}
        <span>Todo List</span>
      </button>

      {/* Expanded content */}
      {isExpanded && (
        <>
          {/* Show output with task parsing */}
          {output && (
            <div className={cn(
              "ml-6",
              isError && "text-destructive"
            )}>
              {isError ? (
                <div className="p-2 bg-destructive/10 rounded">
                  <div className="font-semibold mb-1">Error:</div>
                  <div className="whitespace-pre-wrap">{output}</div>
                </div>
              ) : (
                // Use TaskContent to parse and display tasks
                <TaskContent
                  content={typeof output === 'string' ? output : JSON.stringify(output, null, 2)}
                />
              )}
            </div>
          )}
        </>
      )}
    </div>
  );
};